import { useState, ReactNode } from 'react';
// eslint-disable-next-line
import { unstable_batchedUpdates } from 'react-dom';

export interface FormError {
    userMessage?: string | ReactNode;
    prevented?: boolean;
    handled?: boolean;
    responseText?: string;
    resultCode?: string;
    resultText?: string;
}

type FormSubmissionResult<T> =
    | { hasFormError: false; formError: null; setFormState: (error: T) => void; clearFormState: () => void }
    | { hasFormError: true; formError: T; setFormState: (error: T) => void; clearFormState: () => void };

const useFormSubmission = <T = string>(): FormSubmissionResult<T> => {
    const [formError, setFormError] = useState<T | null>(null);
    const [hasFormError, setHasFormError] = useState(false);

    const setFormState = (error: T) => {
        unstable_batchedUpdates(() => {
            setFormError(error);
            setHasFormError(true);
        });
    };

    const clearFormState = () => {
        unstable_batchedUpdates(() => {
            setFormError(null);
            setHasFormError(false);
        });
    };

    return { setFormState, clearFormState, hasFormError, formError } as FormSubmissionResult<T>;
};

export default useFormSubmission;
